<div class="row pt-4" *ngIf="entity">
  <div class="col-md-4">
    <dl>
      <dt class="h3">{{ 'COMMUNITY_LEAD' | translate }}</dt>
      <dd class="d-flex">
        <app-profile-link
          [dataTestId]="'community-first-lead'"
          [status]="status"
          [userId]="entity.creator.user_id"
          [text]="entity.creator.displayed_name"
        ></app-profile-link>
      </dd>
    </dl>
    <dl *ngIf="entity.website">
      <dt class="h3">{{ 'COMMUNITY_WEBSITE' | translate }}</dt>
      <dd>
        <a data-test-id="community-website" [href]="normalizedLink" target="_blank">
          {{ entity.website }}
        </a>
      </dd>
    </dl>
    <dl>
      <dt class="h3">{{ 'COMMUNITY_LOCATION' | translate }}</dt>
      <dd data-test-id="community-location">
        <a
          class="d-inline-flex align-items-center"
          data-test-id="active-community-location"
          target="_blank"
          [routerLink]="['/map', mapFilters.COMMUNITIES.toLowerCase()]"
          [queryParams]="{ id: entity.entity_id }"
          [ngbTooltip]="'TOOLTIP_SEE_ON_MAP' | translate"
        >
          <svg-icon src="assets/icons/icon-map-pin.svg" class="icon-location-pin mb-1 me-1"></svg-icon>
          <span class="mb-0">{{ location }}</span>
        </a>
      </dd>
    </dl>
    <dl>
      <dt class="h3">{{ 'COMMUNITY_TYPE' | translate }}</dt>
      <dd data-test-id="community-type">{{ entity.type }}</dd>
    </dl>
    <ng-container *ngIf="isHealthCommunity">
      <dl>
        <dt class="h3">{{ 'COMMUNITY_SPECIALITIES' | translate }}</dt>
        <dd data-test-id="community-specialities">
          <span [attr.data-test-id]="'community-specialities'">
            {{ entity.specialities | formatCategories }}
          </span>
        </dd>
      </dl>
      <dl>
        <dt class="h3">{{ 'COMMUNITY_DISEASES_FOCUS' | translate }}</dt>
        <dd data-test-id="community-focus-diseases">
          <span [attr.data-test-id]="'community-focus-diseases'">
            {{ entity.diseases | formatCategories }}
          </span>
        </dd>
      </dl>
    </ng-container>
    <ng-container *ngIf="!isHealthCommunity">
      <dl>
        <dt class="h3">{{ 'COMMUNITY_CHARITY_FOCUS' | translate }}</dt>
        <dd data-test-id="community-focus-charity">
          <span [attr.data-test-id]="'community-focus-charity'">
            {{ entity.charity_focuses | formatCategories }}
          </span>
        </dd>
      </dl>
    </ng-container>
  </div>
  <div class="col-md-8">
    <p class="multi-line-text" data-test-id="community-description">
      {{ entity.description }}
    </p>
  </div>
</div>
<div *ngIf="!entity" class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
  <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
</div>
